export default __webpack_public_path__ + "app-store-button.9ccab3626fe47104ca66d9fb4be0f757.png";